import { RESET } from '../actionTypes';
import { actions } from '../reducer';

export default () => actions[RESET]();
